/**
 * Formato único de error del API del núcleo (`/api/v1`). Los endpoints OAuth usan `OAuthErrorSchema`.
 */
import { z } from "zod";
export const ERROR_CODES = Object.freeze([
    "validation_failed",
    "unauthenticated",
    "forbidden",
    "not_found",
    "conflict",
    "rate_limited",
    "subscription_inactive",
    "limit_exceeded",
    "feature_not_included",
    "internal",
]);
export const ErrorResponseSchema = z.object({
    error: z.object({
        code: z.enum(ERROR_CODES),
        message: z.string(),
        /** Detalle estructurado (p. ej. issues de zod, límite y uso actual). */
        details: z.unknown().optional(),
        /** Id de correlación para soporte. */
        requestId: z.string().optional(),
    }),
});
/** Mapa estándar código → HTTP status. */
export const ERROR_HTTP_STATUS = Object.freeze({
    validation_failed: 400,
    unauthenticated: 401,
    forbidden: 403,
    not_found: 404,
    conflict: 409,
    rate_limited: 429,
    subscription_inactive: 402,
    limit_exceeded: 402,
    feature_not_included: 402,
    internal: 500,
});
//# sourceMappingURL=errors.js.map